import React from 'react';
import FileUploaderOriginal from '@fiverr-private/file_uploader';
import MessageControlWrapper from '../MessageControlWrapper';

export const FileUploader = (props) => (
    <MessageControlWrapper>
        <FileUploaderOriginal {...props}/>
    </MessageControlWrapper>
);
